module.exports = __webpack_public_path__ + "img/Monte_Kope_122.c14696bc.jpg";